import React from 'react';
import { useAppDispatch } from 'redux/store';
import { useNavigate } from 'react-router-dom';

import { Button } from 'react-bootstrap';

import { useAppContext } from 'providers/AppProvider';

import { fetchNodeInstances } from '../../redux/slices/node_instancesSlice';
import { fetchCustomerNodeDefinitions } from '../../redux/slices/customer_node_definitionsSlice';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEraser } from '@fortawesome/free-solid-svg-icons'; // Import the refresh icon

const ResetButton = (props) => {
  const { resetPage, handleReset } = props;

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const {
    config: { theme },
  } = useAppContext();
  const handleRefresh = () => {
    if (resetPage === 'node-instances') {
      navigate('/automation/node_instances', { replace: true });
      dispatch(
        fetchNodeInstances({
          page: 1,
          limit: 100,
          sortColumn: 'node_instance_id',
          sortOrder: 'asc',
          parentOnly: false,
        })
      );
    } else if (resetPage === 'node-definitions') {
      navigate('/automation/node_definitions', { replace: true });
      dispatch(
        fetchCustomerNodeDefinitions({
          page: 1,
          limit: 100,
          type: 'All',
          sortBy: 'node_definition_id',
          sortOrder: 'asc',
        })
      );
    }

    if (handleReset) {
      handleReset();
    }
  };

  return resetPage ? (
    <Button className="mb-2" onClick={handleRefresh} variant="secondary">
      Reset search/filters <FontAwesomeIcon icon={faEraser} size="lg" />
    </Button>
  ) : null;
};
export default ResetButton;
